import moment from 'moment'
import { DateTime } from 'luxon'
import { UserDocumentCategory } from '@/featuresV1/Admin/UserDocumentCategories/userDocumentCategories.slice'
import {
  BookkeepingInternalNames,
  DescriptionType,
} from '@/features/user/your-practice/documents/lib/constants'

export const parseCategoryYear = (internalName?: string) => {
  const match = internalName?.match(/^\d{4}/g)
  return match ? match[0] : null
}

export const getBookkeepingTitle = (
  category: UserDocumentCategory,
  descriptionType?: DescriptionType | null
) => {
  const { internalName, title } = category
  const year = parseCategoryYear(internalName)

  if (
    internalName.includes(BookkeepingInternalNames.CONTRACTOR_PAYMENTS_REPORT)
  ) {
    return 'Contractor payments report'
  }

  if (internalName.includes(BookkeepingInternalNames.LARGE_ASSET_RECEIPTS)) {
    return 'Receipts for assets costing more than $2,500'
  }

  if (
    internalName.includes(BookkeepingInternalNames.PAYMENT_PROCESSOR_REPORTS) &&
    descriptionType === DescriptionType.MERCHANT
  ) {
    return 'Merchant fees report'
  }

  if (
    internalName.includes(BookkeepingInternalNames.PAYMENT_PROCESSOR_REPORTS) &&
    descriptionType === DescriptionType.INCOME &&
    year
  ) {
    return `December ${year} income report`
  }

  return title
}

export const transformMonthYear = (monthYear?: string) => {
  return monthYear ? moment(monthYear, 'YYYY-MM') : undefined
}

export const formatMonthYear = (monthYear?: string) => {
  return monthYear
    ? DateTime.fromFormat(monthYear, 'yyyy-M').toFormat('yyyy-MM')
    : undefined
}
